import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { sessionStore } from './session'
import { frappeRequest } from 'frappe-ui'

export const hcpProfileStore = defineStore('hcp-profile', () => {
  // Default values
  const hcpCompletionPercentage = ref(0)
  
  // Computed properties based on completion percentage
  const canTakeCourses = computed(() => {
    // User can take courses if completion is at least 50%
    return hcpCompletionPercentage.value >= 50
  })
  
  const canApplyForWork = computed(() => {
    // User can apply for jobs if completion is at least 90%
    return hcpCompletionPercentage.value >= 90
  })
  
  // Function to update eligibility based on server-provided completion percentage
  function updateEligibility(serverData) {
    
    if (serverData && serverData.completionPercentage !== undefined) {
       
      // Update the reactive state
      hcpCompletionPercentage.value = serverData.completionPercentage
      
      // Store in localStorage so we can retrieve on page reload
      localStorage.setItem('hcp_completion_percentage', hcpCompletionPercentage.value)
      
      // Log updated eligibility status
     
    } else {
      console.warn('[HCP Store] Invalid data passed to updateEligibility:', serverData)
    }
  }
  
  // Function to initialize from localStorage (call this on app startup)
  function initFromStorage() {
    const storedCompletionPercentage = localStorage.getItem('hcp_completion_percentage')

    
    if (storedCompletionPercentage) {
      hcpCompletionPercentage.value = parseInt(storedCompletionPercentage)

    } else {
    
    }
  }
  
  // Function to fetch latest profile completion from server
  function fetchProfileCompletion() {
    // Get session store
    const { user } = sessionStore()

    // Make sure we're logged in before trying to fetch completion
    if (!user || user === 'Guest') {

      return
    }
    
    
    
    // Use the direct API endpoint we discovered in the logs
    // Use the direct API endpoint we discovered in the logs, but via frappeRequest
    frappeRequest({
      url: 'yene.hcp_api.get_health_care_professional',
      method: 'GET'
    })
      .then(data => {
        // frappeRequest already parses the response and checks for errors,
        // and returns the inner data directly if it's a standard Frappe response.
        // The API returns a dictionary, which frappeRequest passes as 'data'.
        
        if (data) {
          // Check if the API returned a completion percentage directly in the response
          if (data.completion_percentage !== undefined) {
            updateEligibility({ completionPercentage: data.completion_percentage });
          } 
          // Check if it's nested in a 'data' object
          else if (data.data && data.data.completion_percentage !== undefined) {
            updateEligibility({ completionPercentage: data.data.completion_percentage });
          }
          // Also handle the case where it returns message.data because of frappe.whitelist
          else if (data.message && data.message.completion_percentage !== undefined) {
            updateEligibility({ completionPercentage: data.message.completion_percentage });
          }
          else if (data.message && data.message.data && data.message.data.completion_percentage !== undefined) {
            updateEligibility({ completionPercentage: data.message.data.completion_percentage });
          }
          else {
            console.warn('[HCP Store] API response missing completion_percentage field:', data);
            // Set a default value based on success field
            if (data.success || (data.message && data.message.success)) {
              updateEligibility({ completionPercentage: 100 });
            }
          }
        } else {
          console.error('[HCP Store] Invalid API response format:', data);
        }
      })
      .catch(error => {
        console.error('[HCP Store] API call failed:', error);
        // Try fallback to localStorage if available
        const storedPercentage = localStorage.getItem('hcp_completion_percentage');
        if (storedPercentage) {
          updateEligibility({ completionPercentage: parseInt(storedPercentage) });
        }
      });
  }
  
  return {
    canTakeCourses,
    canApplyForWork,
    hcpCompletionPercentage,
    updateEligibility,
    initFromStorage,
    fetchProfileCompletion
  }
})
